import React, { useEffect, useState } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";


const ConfirmationLetter = () => {
  const centerCode = localStorage.getItem("code");
  const [refError, setRefError] = useState("");
const refInputRef = useRef(null);


  /* ---------------- RECEIPT SELECT ---------------- */
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState([]);
  const [selectedReceipts, setSelectedReceipts] = useState([]);
  const token = localStorage.getItem("token");
  const [mrOptions, setMrOptions] = useState([]);
  const [letterGenerated, setLetterGenerated] = useState(false);
  const pin = localStorage.getItem("pin");
  const sewadarId = localStorage.getItem('sewadarId');
const location = useLocation();
const letterId = location.state?.letterId || null;
const isEdit = Boolean(letterId);

/* ---------------- REF NO ---------------- */
const [refSuffix, setRefSuffix] = useState("");

/* ---------------- DATE ---------------- */
const [letterDate, setLetterDate] = useState("");
const editInitializedRef = useRef(false);
const getRefYear = () => {
  if (letterDate) {
    return moment(letterDate)?.year();
  }
  return moment().year();
};

const REF_PREFIX = `F.66.G Stores/RSSB/JP/RJ/${getRefYear()}/`;

  const navigate = useNavigate();
  /* ---------------- FOOTER ---------------- */
  const [noteText, setNoteText] = useState(
    "1. Freight to be Paid for above mentioned invoices: NIL"
  );
  
  const [enclText, setEnclText] = useState(
    "1 Original Invoice"
  );


  /* ---------------- ADDRESS (PARAGRAPH) ---------------- */
  const [addressText, setAddressText] = useState(
    `Sewadar Incharge,
Purchase Department,
Radha Soami Satsang Beas,
P.O. Dera Baba Jaimal Singh,
Distt. Amritsar, Punjab - 143204`
  );

  /* ---------------- TEXT ---------------- */
  const [subject, setSubject] = useState(
    "Receipt of material in Direct Delivery - Attached to Zone-II"
  );
  const [dearLine, setDearLine] = useState("Dear Brother,");
  const [bodyText, setBodyText] = useState(
    "We confirm having received the following material through Zonal Purchase Cell, Ludhiana / Delhi, at Jaipur-I-Centre (Bilwa) for project mentioned below"
  );

  /* ---------------- TABLE ---------------- */
  const [tableRows, setTableRows] = useState([]);
  const fetchMRs = async () => {
    const res = await apiClient.get(`${SERVER_BASE}/get-mrs`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setMrOptions(
      res.data.data.map((mr) => ({
        value: mr.id,
        label: `${mr.mrNo} - ${mr.remarks}`,
        raw: mr,
      }))
    );
  };

  useEffect(() => {
    fetchMRs();
  }, []);

  /* ---------------- FETCH RECEIPTS ---------------- */
  const fetchVouchers = async () => {
    try {
      setLoading(true);
  
      const res = await apiClient.get(
        `${SERVER_BASE}/getReceiptVouchers/${centerCode}`
      );
  
      let vouchers = res.data || [];

      // ✅ If NOT edit mode → show only vouchers where confirmationLetter != 1
      if (!isEdit) {
        vouchers = vouchers.filter(v => v.letter != "1" && v.letterType != 'Confirmation');
      }
  
      setReceiptData(vouchers);
  
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch receipt vouchers", "error");
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchVouchers();
  }, []);

  const receiptOptions = receiptData.map((r) => ({
    value: r.id,
    label: `${r.documentNo} - ${r.ledgerName} - ${
      r.date ? moment(r.date).format("DD MMM YY") : ""
    }`,
  }));
  const checkRefNoOnBlur = async () => {
    if (!refSuffix || !refSuffix.trim()) {
      setRefError("");
      return;
    }
  
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/check-ref/${refSuffix}`,
        {
          params: isEdit ? { excludeId: letterId } : {},
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      if (res.data.exists) {
        setRefError("This Ref. No already exists");
  
        Swal.fire({
          icon: "error",
          text: "This Ref. No already exists. Please use a different number.",
          toast: true,
          timer: 3000,
          showConfirmButton: false,
          position: "top-end",
        });
  
        setRefSuffix("");
        setTimeout(() => refInputRef.current?.focus(), 0);
      } else {
        setRefError("");
      }
    } catch (err) {
      console.error(err);
    }
  };
  
  const deriveProjectsFromMrIds = (mrIds = [], mrOptions = []) => {
    const projectMap = new Map();
  
    mrOptions.forEach(mr => {
      if (mrIds.includes(mr.value)) {
        const key = mr.raw.projectId || mr.raw.projectName;
  
        if (!projectMap.has(key)) {
          projectMap.set(key, {
            projectName: mr.raw.projectName,
            description: mr.raw.description || "",
            centerName: mr.raw.centerName || "",
          });
        }
      }
    });
  
    return Array.from(projectMap.values());
  };
  useEffect(() => {
    if (!letterId || receiptOptions.length === 0) return;
    if (editInitializedRef.current) return;
  
    const fetchLetter = async () => {
      const res = await apiClient.get(
        `${SERVER_BASE}/confirmation-letter/${letterId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      const d = res.data;
  
      setRefSuffix(d.refNo);
      setLetterDate(d.letterDate);
      setSubject(d.subject);
      setDearLine(d.dearLine);
      setBodyText(d.bodyText);
      setAddressText(d.addressText);
      setNoteText(d.noteText);
      setEnclText(d.enclText);
  
      setSelectedReceipts(
        receiptOptions.filter(o =>
          d.receipts.some(r => r.receiptId == o.value)
        )
      );
      const flattened = flattenReceipts(d.receipts);

      /* 🔥 RE-DERIVE PROJECTS FROM MR IDS */
      flattened.forEach(row => {
        if (row.mrIds && row.mrIds.length > 0) {
          row.projects = deriveProjectsFromMrIds(row.mrIds, mrOptions);
        }
      });
      
      setTableRows(flattened);
      editInitializedRef.current = true;
    };
  
    fetchLetter();
  }, [letterId, receiptOptions, mrOptions]);


  const handleCreateLetter = async () => {
    if (!selectedReceipts.length) {
      Swal.fire("Warning", "Please select at least one receipt", "warning");
      return;
    }
  
    try {
      setLoading(true);
  
      // Selected receipt IDs
      const selectedIds = new Set(selectedReceipts.map(r => Number(r.value)));
  
      // Existing receipt IDs already in table
      const existingIds = new Set(tableRows.map(r => Number(r.receiptId)));
  
      // Keep only rows that are still selected (handle removal)
      const updatedRows = tableRows.filter(row =>
        selectedIds.has(Number(row.receiptId))
      );
  
      // Find newly added receipts
      const newlyAdded = selectedReceipts.filter(
        r => !existingIds.has(Number(r.value))
      );
  
      // Nothing new → just update removals
      if (newlyAdded.length === 0) {
        setTableRows(updatedRows);
        return;
      }
  
      /* ---------------- FETCH ONLY NEW RECEIPTS ---------------- */
      const receiptIds = newlyAdded.map(r => r.value);
  
      const res = await apiClient.post(
        `${SERVER_BASE}/getConfirmationLetterData`,
        { receiptIds }
      );
  
      const newRows = [];
  
      res.data.forEach(rv => {
        const itemMap = new Map();
  
        rv.items.forEach(item => {
          const itemId = item.itemMaster.id;
          if (!itemMap.has(itemId)) {
            itemMap.set(itemId, {
              receiptId: rv.id,
              supplier: rv.ledgerName,
              invoiceNo: rv.documentNo,
              invoiceDate: rv.documentDate,
  
              itemId,
              hsn: item.itemMaster?.hsn || "",
              itemCode: item.itemMaster?.mmsCode || "",
              item: item.itemMaster?.mmsName || "",
  
              primaryQty: Number(item.challanQty) || 0,
              receivedQty: Number(item.receivedQty) || 0,
  
              primaryUom: item.uom,
              secondaryUom: item.itemMaster?.secondaryUom,
  
              conversionPrimaryQty:
                item.itemMaster?.primaryQuantity || null,
              conversionSecondaryQty:
                item.itemMaster?.secondaryQuantity || null,
  
              quality: getQualityText({
                primaryQty: item.challanQty,
                receivedQty: item.receivedQty,
                primaryUom: item.uom,
              }),
  
              amount: "",
              mrIds: [],
              projects: [],
 
              receiptVoucherItems: [
                {
                  id: item.id,
                  challanQty: Number(item.challanQty) || 0,
                  receivedQty: Number(item.receivedQty) || 0,
                }
              ],
              
            });
          } else {
            const existing = itemMap.get(itemId);
            existing.primaryQty += Number(item.challanQty) || 0;
            existing.receivedQty += Number(item.receivedQty) || 0;
            existing.receiptVoucherItems.push({
              id: item.id,
              challanQty: Number(item.challanQty) || 0,
              receivedQty: Number(item.receivedQty) || 0,
            });
            
          }
        });
  
        // Convert map → rows with proper rowspan
        const groupedRows = Array.from(itemMap.values());
        groupedRows.forEach((row, idx) => {
          newRows.push({
            ...row,
            showHeader: idx == 0,
            rowSpan: groupedRows.length,
          });
        });
      });
  
      /* ---------------- MERGE OLD + NEW ---------------- */
      setTableRows([...updatedRows, ...newRows]);
  
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load receipt data", "error");
    } finally {
      setLoading(false);
    }
  };
  

  const getQualityText = (row) => {
    const issued = Number(row.primaryQty);
    const received = Number(row.receivedQty);
    const uom = row.primaryUom;
  
    if (!isFinite(issued) || !isFinite(received)) {
      return `No Breakage
  No Shortage
  Quality Ok`;
    }
  
    if (received == issued) {
      return `No Breakage
  No Shortage
  Quality Ok`;
    }
  
    const diff = Math.abs(received - issued);
  
    if (received < issued) {
      return `No Breakage
  Shortage : ${diff?.toFixed(2)} ${uom}
  Quality Ok`;
    }
  
    if (received > issued) {
      return `No Breakage
  Excess : ${diff?.toFixed(2)} ${uom}
  Quality Ok`;
    }
  
    return `No Breakage
  No Shortage
  Quality Ok`;
  };
  
  const handleMrChange = (rowIndex, selectedMrs) => {
    const updated = [...tableRows];
    const receiptId = updated[rowIndex].receiptId;
  
    const mrIds = selectedMrs ? selectedMrs.map(m => m.value) : [];
  
    const projectMap = new Map();
  
    (selectedMrs || []).forEach(mr => {
      const key = mr.raw.projectId || mr.raw.projectName;
  
      if (!projectMap.has(key)) {
        projectMap.set(key, {
          projectName: mr.raw.projectName,
          description: mr.raw.description || "",
          centerName: mr.raw.centerName || "",
        });
      }
    });
  
    const projects = Array.from(projectMap.values());
  
    updated.forEach(row => {
      if (row.receiptId == receiptId) {
        row.mrIds = mrIds;
        row.projects = projects;
      }
    });
  
    setTableRows(updated);
  };

  const updateRow = (rowIndex, field, value) => {
    const updated = [...tableRows];
    updated[rowIndex][field] = value;
    setTableRows(updated);
  };

  const getSecondaryQty = (row) => {

    if (
      !row.secondaryUom ||
      row.secondaryUom == row.primaryUom ||
      !row.conversionPrimaryQty ||
      !row.conversionSecondaryQty
    ) {
   return null;
    }

    const calculated =
      (Number(row.primaryQty) / Number(row.conversionPrimaryQty)) *
      Number(row.conversionSecondaryQty);

    if (!isFinite(calculated)) return null;

    return calculated;
  };
  const validateForm = () => {

    // if (!refSuffix || !refSuffix.trim()) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Ref No is required",
    //     timer: 2500,
    //     showConfirmButton: false,
    //     toast:true,
    //     timerProgressBar:true,
    //     position:'top-end'
    //   })
    //   return false;
    // }

    // if (!letterDate) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Date is required",
    //     timer: 2500,
    //     showConfirmButton: false,
    //     toast:true,
    //     timerProgressBar:true,
    //     position:'top-end'
    //   })
  
    //   return false;
    // }

    const receiptMap = {};
  
    tableRows.forEach(row => {
      if (!receiptMap[row.receiptId]) {
        receiptMap[row.receiptId] = {
          amount: row.amount,
          mrIds: row.mrIds || []
        };
      }
    });

    for (const [receiptId, data] of Object.entries(receiptMap)) {
      if (!data.amount || Number(data.amount) <= 0) {
        Swal.fire({
          icon: "warning",
          text: "Amount is required for all selected receipts",
          timer: 2500,
          showConfirmButton: false,
          toast:true,
          timerProgressBar:true,
          position:'top-end'
        })
        return false;
      }
  
      if (!data.mrIds || data.mrIds.length === 0) {

        Swal.fire({
          icon: "warning",
          text: "Please select MR for all selected receipts",
          timer: 2500,
          showConfirmButton: false,
          toast:true,
          timerProgressBar:true,
          position:'top-end'
        })
        return false;
      }
    }
    if (!tableRows.length) {
      Swal.fire({
        icon: "warning",
        text: "No data to save",
        timer: 2500,
        showConfirmButton: false,
        toast:true,
        timerProgressBar:true,
        position:'top-end'
      })
      return false;
    }
  
    return true;
  };
const handleSave = async () => {
  try {
    if (!validateForm()) return;
    const confirmResult = await Swal.fire({
      title: "Confirm Save",
      text: "Enter your PIN to save this confirmation letter.",
      icon: "warning",
      input: "password",
      inputPlaceholder: "Enter PIN",
      inputAttributes: {
        maxlength: 6,
        autocapitalize: "off",
        autocorrect: "off",
      },
      showCancelButton: true,
      confirmButtonText: isEdit ? "Update" : "Save",
      cancelButtonText: "Cancel",
      preConfirm: (enteredPin) => {
        if (!enteredPin) {
          Swal.showValidationMessage("PIN is required");
          return false;
        }
        if (enteredPin !== pin) {
          Swal.showValidationMessage("Invalid PIN");
          return false;
        }
        return true;
      },
    });

    if (!confirmResult.isConfirmed) return;

    const receiptMap = {};

    tableRows.forEach(row => {
      if (!receiptMap[row.receiptId]) {
        receiptMap[row.receiptId] = {
          receiptId: row.receiptId,
          amount: row.amount,
          mrIds: row.mrIds || [],
          items: []
        };
      }

row.receiptVoucherItems?.forEach(rvItemId => {
  receiptMap[row.receiptId].items.push({
    receiptVoucherItemId: rvItemId.id, // ✅ SINGLE ID
    hsn: row.hsn,
    itemCode: row.itemCode,
    itemName: row.item,
    itemId: row.itemId,
    primaryQty: rvItemId.challanQty,     // summed qty (ok)
    primaryUom: row.primaryUom,
    secondaryQty: getSecondaryQty(row),
    secondaryUom: row.secondaryUom,
    quality: row.quality
  });
});

    });

    const payload = {
      refNo: `${refSuffix}`,
      letterDate,
      subject,
      dearLine,
      bodyText,
      addressText,
      noteText,
      enclText,
      receipts: Object.values(receiptMap),
      centerCode: localStorage.getItem("code"),
    createdBy:sewadarId,
    status:(!refSuffix || !refSuffix.trim() || !letterDate) ?'Draft':'Pending'
    };

    const url = isEdit
      ? `${SERVER_BASE}/updateConfirmationLetter/${letterId}`
      : `${SERVER_BASE}/saveConfirmationLetter`;

    const method = isEdit ? "put" : "post";

    const response = await apiClient[method](url, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Swal.fire({
      icon: "success",
      text: response?.data?.message,
      timer: 1500,
      showConfirmButton: false,
      toast: true,
      timerProgressBar: true,
      position: "top-end",
    }).then(() => {
      navigate("../dashboard/ConfirmationLetterList");
    });

  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Something went wrong while saving", "error");
  }
};

const getReceiptMeta = (receiptId) => {
  return receiptData.find(r => r.id == receiptId);
};

const flattenReceipts = (receipts = []) => {
  const rows = [];

  receipts.forEach((r) => {
    const receiptMeta = getReceiptMeta(r.receiptId) || {};
    const itemMap = new Map();

    // ✅ Build a map of itemId -> itemMaster from receiptMeta.items
    const masterMap = new Map();
    (receiptMeta?.items || []).forEach((x) => {
      const itemId = x?.itemMaster?.id;
      if (itemId != null) {
        masterMap.set(String(itemId), x.itemMaster);
      }
    });

    (r.items || []).forEach((item) => {
      const key = String(item.itemId);

      // ✅ Fetch itemMaster using itemId
      const master = masterMap.get(String(item.itemId));

      if (!itemMap.has(key)) {
        itemMap.set(key, {
          receiptId: r.receiptId,

          supplier: receiptMeta.ledgerName || "",
          invoiceNo: receiptMeta.documentNo || "",
          invoiceDate: receiptMeta.date || "",

          itemId: item.itemId,
          hsn: item.hsn,
          itemCode: item.itemCode,
          item: item.itemName,

          primaryQty: Number(item.primaryQty) || 0,
          primaryUom: item.primaryUom,

          // ✅ conversion comes from receiptMeta.items.itemMaster
          conversionPrimaryQty: master?.primaryQuantity || null,
          conversionSecondaryQty: master?.secondaryQuantity || null,

          secondaryQty: Number(item.secondaryQty) || 0,

          // ✅ secondaryUOM also from itemMaster (fallback to saved value)
          secondaryUom: master?.secondaryUom || item.secondaryUom || null,

          quality: item.quality,
          amount: r.amount || "",

          mrIds: r.mrIds || [],
          projects: r.projects || [],

          // ✅ store detailed voucher item references (for saving later)
          receiptVoucherItems: [
            {
              id: item.receiptVoucherItemId,
              challanQty: Number(item.primaryQty) || 0,
              receivedQty: Number(item.primaryQty) || 0,
            },
          ],
        });
      } else {
        const existing = itemMap.get(key);

        // ✅ Sum qty
        existing.primaryQty += Number(item.primaryQty) || 0;
        existing.secondaryQty += Number(item.secondaryQty) || 0;

        // ✅ Keep conversions if missing
        existing.conversionPrimaryQty =
          existing.conversionPrimaryQty || master?.primaryQuantity || null;

        existing.conversionSecondaryQty =
          existing.conversionSecondaryQty || master?.secondaryQuantity || null;

        // ✅ Keep secondary UOM
        existing.secondaryUom =
          existing.secondaryUom || master?.secondaryUom || item.secondaryUom || null;

        // ✅ Preserve detail
        existing.receiptVoucherItems.push({
          id: item.receiptVoucherItemId,
          challanQty: Number(item.primaryQty) || 0,
          receivedQty: Number(item.primaryQty) || 0,
        });
      }
    });

    const grouped = Array.from(itemMap.values());

    grouped.forEach((row, idx) => {
      rows.push({
        ...row,
        showHeader: idx === 0,
        rowSpan: grouped.length,
      });
    });
  });

  return rows;
};



  return (
    <div className="">
      {/* RECEIPT SELECT */}
      <div className="card mb-3">
        <div className="card-body">
          <div className="row align-items-end">
       <div className="">   <button
          className="btn btn-secondary btn-sm no-print"
          onClick={() => { navigate('../dashboard/ConfirmationLetterList') }}
        >
          Back
        </button></div>
            <div className="col-md-7">
              <label className="fw-bold">Select Receipt No(s)</label>
              <Select
  isMulti
  options={receiptOptions}
  value={selectedReceipts}
  onChange={setSelectedReceipts}
  isLoading={loading}
  placeholder="Select receipt numbers..."
  getOptionValue={(opt) => String(opt.value)}
  getOptionLabel={(opt) => opt.label}
/>

            </div>
            <div className="col-md-3">
              <button
                className="btn btn-primary w-100"
                onClick={handleCreateLetter}
              >
                Create Letter
              </button>
            </div>
          

         
          </div>
        </div>
      </div>

      {/* LETTER */}
      {tableRows.length > 0 && (
        <div className="border p-4">
          {/* HEADER */}
          <div className="d-flex justify-content-between mb-3">
            <div className="w-50">
              <label className="fw-bold">Ref. No.</label>
              <div className="input-group">
                <span className="input-group-text bg-light fw-bold">
                  {REF_PREFIX}
                </span>
                <input
  ref={refInputRef}
  className={`form-control ${refError ? "is-invalid" : ""}`}
  placeholder="Enter number"
  value={refSuffix}
  onChange={(e) => setRefSuffix(e.target.value)}
  onBlur={checkRefNoOnBlur}
/>

              </div>
{refError && <div className="invalid-feedback">{refError}</div>}

            </div>

            <div>
              <label className="fw-bold">Dated</label>
              <input
                type="date"
                className="form-control"
                value={letterDate}
                onChange={(e) => setLetterDate(e.target.value)}
              />
            </div>
          </div>

          {/* ADDRESS */}
          <div className="mb-3">
            <textarea
              className="form-control"
              rows={5}
              value={addressText}
              onChange={(e) => setAddressText(e.target.value)}
            />
          </div>

          {/* SUBJECT */}
          <div className="mb-2">
            <strong>Sub.:</strong>
            <input
              className="form-control fw-bold"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          {/* DEAR */}
          <input
            className="form-control mb-2"
            value={dearLine}
            onChange={(e) => setDearLine(e.target.value)}
          />

          {/* BODY */}
          <textarea
            className="form-control mb-3"
            rows={3}
            value={bodyText}
            onChange={(e) => setBodyText(e.target.value)}
          />

          {/* TABLE */}
          <table className="table table-bordered text-center align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Supplier Name</th>
                <th>Invoice & Date</th>
                <th>Amount in Rs</th>
                <th>HSN</th>
                <th>Item Code</th>
                <th>Item</th>
                <th colSpan={2}>Billed. Qty.</th>
                <th>Quality</th>
                <th>Project# <br />
                  Order#</th>
              </tr>
            </thead>

            <tbody>
              {tableRows.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>

                  {/* SUPPLIER (MERGED & WRAPPED) */}
                  {row.showHeader && (
                    <td
                      rowSpan={row.rowSpan}
                      className="align-middle text-wrap"
                      style={{ whiteSpace: "pre-line", maxWidth: "180px" }}
                    >
                      {row.supplier}
                    </td>
                  )}

                  {/* INVOICE (MERGED) */}
                  {row.showHeader && (
                    <td rowSpan={row.rowSpan} className="align-middle">
                      {row.invoiceNo} <br /> DATED <br /> 
                      {row.invoiceDate ? moment(row.invoiceDate).format('DD MMM YY'):"" }
                    </td>
                  )}

                  {/* AMOUNT (MERGED, EDITABLE) */}
                  {row.showHeader && (
                    <td style={{width:"120px"}} rowSpan={row.rowSpan} className="align-middle">
                      <input
                        type="number"
                        className="form-control"
                        value={row.amount}
                        onChange={(e) => updateRow(i, "amount", e.target.value)}
                      />
                    </td>
                  )}

                  <td>{row.hsn}</td>
                  <td>{row.itemCode}</td>
                  <td>{row.item}</td>
                 
                  <td>
                    <div>{row.primaryQty}</div>

                    {getSecondaryQty(row) != null && (
                      <div style={{ fontSize: "12px", color: "#555" }}>
                        ({getSecondaryQty(row)})
                      </div>
                    )}
                  </td>

                  {/* BILLED QTY – UOM COLUMN */}
                  <td>
                    <div>{row.primaryUom}</div>

                    {getSecondaryQty(row) != null && (
                      <div style={{ fontSize: "12px", color: "#555" }}>
                        {row.secondaryUom}
                      </div>
                    )}
                  </td>

                  {/* QUALITY */}
                  <td>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={row.quality}
                      onChange={(e) => updateRow(i, "quality", e.target.value)}
                    />
                  </td>

                  {row.showHeader && (
                  <td
                  rowSpan={row.rowSpan}
                  className="align-middle"
                  style={{
                    minWidth: "250px",
                    maxWidth: "250px",    
                    verticalAlign: "top",
                  }}
                >
                      <Select
  isMulti
  options={mrOptions}
  value={mrOptions.filter(m => row.mrIds?.includes(m.value))}
  onChange={(mrs) => handleMrChange(i, mrs)}
  placeholder="Select MR(s)"
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    container: (base) => ({
      ...base,
      width: "100%",
      maxWidth: "250px",   
    }),
    control: (base) => ({
      ...base,
      minHeight: "38px",
      maxWidth: "250px",
      overflow: "hidden",
    }),
    valueContainer: (base) => ({
      ...base,
      display: "flex",
      flexWrap: "wrap",    
      maxHeight: "90px",   
      overflowY: "auto",
    }),
    multiValue: (base) => ({
      ...base,
      maxWidth: "100%",
    }),
    multiValueLabel: (base) => ({
      ...base,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "120px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
/>
                   {row.projects && row.projects.length > 0 && (
  <div
    style={{
      maxHeight: "160px",    
      overflowY: "auto",
    }}
  >
    {row.projects.map((p, idx) => (
      <div
        key={idx}
        style={{
          marginBottom: "8px",
          paddingBottom: "6px",
          borderBottom:
            idx !== row.projects.length - 1 ? "1px dashed #ccc" : "none",
          whiteSpace: "pre-line",
          wordBreak: "break-word",
          overflowWrap: "anywhere", 
          fontSize: "13px",
          lineHeight: "1.4",
        }}
      >
        <strong># PROJECT – {p.projectName}</strong>
        {p.description && <div>{p.description}</div>}
        {p.centerName && <div>{p.centerName}</div>}
      </div>
    ))}
  </div>
)}

                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          {/* FOOTER */}
<div className="d-flex justify-content-between mt-4">
  <div style={{ width: "60%" }}>
    <strong>Note:</strong>
    <textarea
      className="form-control mb-2"
      rows={2}
      value={noteText}
      onChange={(e) => setNoteText(e.target.value)}
    />

    <strong>Encl:</strong>
    <textarea
      className="form-control"
      rows={1}
      value={enclText}
      onChange={(e) => setEnclText(e.target.value)}
    />
  </div>
</div>
<div className="d-flex justify-content-end">
  <button
    className="btn btn-success"
    onClick={handleSave}
  >
    Confirm & Approve
  </button>
</div>
        </div>
        
      
      )}
      



    </div>
  );
};

export default ConfirmationLetter;
